var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "7504 737 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-icon-instagram2);\n      }\n\n      .cls-2, .cls-3, .cls-61 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        stroke-width: 7px;\n      }\n\n      .cls-3 {\n        stroke-width: 5px;\n      }\n\n      .cls-51 {\n        stroke: none;\n      }\n      .cls-63 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-instagram2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7504,
    y: 737,
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-instagram2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    className: "cls-2",
    transform: "translate(7504 737)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    width: 80,
    height: 80,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 3.5,
    y: 3.5,
    width: 73,
    height: 73,
    rx: 16.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    className: "cls-3",
    transform: "translate(7524 757)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 20,
    cy: 20,
    r: 17.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    className: "cls-4",
    transform: "translate(7562 752)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 5,
    cy: 5,
    r: 4.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram2);
export default __webpack_public_path__ + "static/media/icon-instagram2.a1cdcc5ef50009e6fde284c477f7060c.svg";
export { ForwardRef as ReactComponent };